export const LANGUAGES_SELECT_OPTIONS = [
  {
    value: "tr",
    label: "TR",
  },
  {
    value: "en",
    label: "EN",
  },
];
